import { useContext, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { TEST_MODE } from "../../components/common/consts";
import { setControlPoliticMute, setShownControls } from "../../store/commonSlice";
import { useAppSelector } from "../../store/index.ts";
import { AudioContextRef } from "../../pages/CurrentModel.jsx";
const DELAY_CLEAR_VIDEO = 5 * 1000;
// const DELAY_CLEAR_VIDEO = 500 * 1000;

export default function useVideoControls() {
  const dispatch = useDispatch();
  const audioRef = useContext(AudioContextRef);
  const isShownControl = useAppSelector((state) => state.common.controls.isShown);
  const isMobile = useAppSelector((state) => state.deviceSize.isMobile);

  const clearVideoIdRef = useRef(null);
  const touchTimerId = useRef(null);

  const goHideControls = () => {
    clearTimeout(clearVideoIdRef.current);
    clearVideoIdRef.current = setTimeout(
      () => dispatch(setShownControls(false)),
      DELAY_CLEAR_VIDEO
    );
  };

  const onMouseEnter = () => !isMobile && dispatch(setShownControls(true));
  const onMouseLeave = () => !isMobile && goHideControls();

  const onTouchClick = () => {
    clearTimeout(touchTimerId.current);
    touchTimerId.current = setTimeout(() => dispatch(setShownControls(!isShownControl)), 300);
  };

  const onUnMute = () => {
    dispatch(setControlPoliticMute(false));
    audioRef.current?.play();
  };

  const onLoadedAudioData = (e) => {
    e.target.play().catch(() => dispatch(setControlPoliticMute(true)));
  };

  useEffect(() => {
    clearVideoIdRef.current = setTimeout(() =>
      dispatch(setShownControls(false), DELAY_CLEAR_VIDEO)
    );

    if (TEST_MODE) setControlPoliticMute(true);
    return () => clearTimeout(clearVideoIdRef.current);
  }, [clearVideoIdRef]);

  return { onMouseEnter, onMouseLeave, onTouchClick, onUnMute, onLoadedAudioData };
}
